var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92563 6.39211C5.62654 6.93141 3.8314 8.72655 3.2921 11.0256C2.90263 12.686 2.90263 14.414 3.2921 16.0744C3.8314 18.3735 5.62655 20.1686 7.92564 20.7079C9.58601 21.0974 11.314 21.0974 12.9744 20.7079C15.2734 20.1686 17.0686 18.3735 17.6079 16.0744M7.92563 6.39211C9.58601 6.00264 11.314 6.00264 12.9744 6.39211C15.2734 6.93141 17.0686 8.72656 17.6079 11.0256C17.9974 12.686 17.9974 14.414 17.6079 16.0744M7.92563 6.39211C7.52772 6.48545 7.14491 6.61641 6.78108 6.78108C7.56789 5.04278 9.12447 3.73806 11.0256 3.2921C12.686 2.90263 14.414 2.90263 16.0744 3.2921C18.3735 3.8314 20.1686 5.62655 20.7079 7.92563C21.0974 9.58601 21.0974 11.314 20.7079 12.9744C20.2619 14.8755 18.9572 16.4321 17.2189 17.2189C17.3836 16.8551 17.5145 16.4723 17.6079 16.0744",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12L9.3906 13.2604C10.0624 13.7083 10.9376 13.7083 11.6094 13.2604L13.5 12",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationsIcon);
export default __webpack_public_path__ + "static/media/organizationsIcon.7a2a43c116348b330e5e752792cd2abc.svg";
export { ForwardRef as ReactComponent };